import { Component, OnInit, Input } from "@angular/core";
import * as Highcharts from "highcharts";
import { takeRight } from "lodash";

@Component({
  selector: "sparkline-extended",
  templateUrl: "./sparkline-extended.component.html",
  styleUrls: ["./sparkline-extended.component.scss"],
})
export class SparklineExtendedComponent implements OnInit {
  options: Object;
  toolTipText: string;
  toolTipTitle: string;
  Highcharts = Highcharts;
  @Input()
  chartData;
  @Input()
  categories;
  @Input()
  dataSuffix;
  @Input()
  dataPrefix;
  @Input()
  subTitle;
  @Input()
  periodicity;
  @Input()
  studentFirstName;
  @Input()
  roundTo;
  @Input()
  min;
  @Input()
  max;

  ngOnInit() {
    if (
      this.periodicity == "ongoing" ||
      this.periodicity == "periodic" ||
      this.periodicity == "monthly"
    ) {
      // show last two years of data for ongoing and periodic metrics
      this.chartData = takeRight(this.chartData, 2);
    } else if (
      this.periodicity == "annual" &&
      this.chartData &&
      this.chartData[0] &&
      this.chartData[0].data
    ) {
      // show last three years of data for annual metrics
      this.chartData[0] = {
        ...this.chartData[0],
        data: takeRight(this.chartData[0].data, 3),
      };
    }
    this.createChart();
  }

  createChart() {
    var self = this;

    this.options = {
      chart: {
        type: "line",
        backgroundColor: null,
      },
      xAxis: {
        type: "category",
        categories: this.categories,
        labels: {
          formatter: function () {
            return (
              '<span style="fill: #929292; text-overflow: none; font-size: 1rem">' +
              this.value +
              "</span>"
            );
          },
        },
        title: {
          text: null,
        },
        gridLineWidth: 0,
        lineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: "transparent",
        minorTickLength: 0,
        tickLength: 0,
      },
      yAxis: {
        min: Math.floor(this.min),
        max: Math.ceil(this.max),
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
        title: {
          text: null,
        },
      },
      title: { text: null },
      subtitle: { text: null },
      series: this.chartData,
      credits: false,
      plotOptions: {
        line: {
          marker: {
            symbol: "circle",
          },
          lineWidth: 1.5,
          slicedOffset: 0,
          size: "100%",
        },
        series: {
          label: {
            enabled: false,
          },
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        shared: false,
        useHTML: true,
        hideDelay: 0,
        borderColor: "#aaa",
        backgroundColor: "rgba(255, 255, 255, 1.0)",
        shadow: false,
        headerFormat: "",
        style: {
          fontFamily: "'Lato', Helvetica, sans-serif",
          backgroundColor: "#FFFFFF",
          zIndex: 9999,
        },
        formatter: function () {
          if (self.subTitle == "Trend by Month") {
            self.toolTipText =
              (self.studentFirstName !== "" && self.studentFirstName !== "-----"
                ? self.studentFirstName
                : "This student") +
              ` ${this.point.descriptor} as of ${this.point.name} ${this.series.name}`;
          } else {
            self.toolTipText =
              (self.studentFirstName !== "" && self.studentFirstName !== "-----"
                ? self.studentFirstName
                : "This student") +
              ` ${this.point.descriptor} in ${this.point.name} ${this.series.name}`;
          }
          self.toolTipTitle = `${this.point.name} ${this.series.name}`;

          return (
            `<div>
                    <span class="metric-tooltip title capitalize tile_body">${self.toolTipTitle}</span>
                    <span class="metric-tooltip value tooltip_value" style="color:${this.point.color}">` +
            (this.point.alphaValue
              ? this.point.alphaValue
              : `${self.dataPrefix || ""}${
                  this.point.y != null
                    ? this.point.y.toLocaleString(undefined, {
                        minimumFractionDigits: self.roundTo,
                        maximumFractionDigits: self.roundTo,
                      })
                    : ""
                }${self.dataSuffix}`) +
            `</span>
                  </div>
                  <div class="metric-tooltip description body_tooltip_text">${self.toolTipText}</div>`
          );
        },
      },
    };
  }
}
